import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/services/authentication.service';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit {
  items: MenuItem[];
  currentUser:any;
  interviewrDashboardRedirect:any;
  constructor(private authenticationService: AuthenticationService,private _router:Router){
  }
  ngOnInit() {
     if(this.authenticationService.currentUserValue){
        this.currentUser = this.authenticationService.currentUserValue['user'];
        console.log(this.currentUser, 20)
     }
     if(this.currentUser.role.id == 1){
      this.items = [
        { label: 'Assign User & Role', icon: 'fa fa-logout', routerLink: '/assign-user-role'},
        { label: 'Technology', icon: 'fa fa-logout', routerLink: '/technology-add-edit'},
        { label: 'Agency', icon: 'fa fa-logout', routerLink: '/agency-add-edit'},
        { label: 'Logout', icon: 'fa fa-logout' , routerLink: '/login'}
      ];
     }
     else {
    this.items = [
      { label: 'Logout', icon: 'fa fa-logout' , routerLink: '/login'}
    ];
  }
    if (window.sessionStorage.interviewrDashboardRedirect == 1) {
      this.interviewrDashboardRedirect = true;
    }
    else{
      this.interviewrDashboardRedirect = false;
    }
  }
}
